import validation from '../../../services/validation';
import { isRosreestrFeatureEnabled } from '../../../services/ad-state.service';

import { initializeHintClickTracking } from '../../../utils/hint-tracking';

import template from './cadastral-number.jade';

export default angular
  .module('cian.addForm.commonCadastralNumber', [])
  .directive('cianAfCommonCadastralNumber', [() => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'analyticsService',
      '$scope',
      'deviceService',
      'popupService',
      function (analyticsService, $scope, deviceService, popupService) {
        'ngInject';
        this.isMobile = deviceService.isMobile;
        this.validation = validation(this.form, 'cadastralNumber', {
          maxlength: 'Допустимо не более 30 символов',
        });

        this.shouldDisplay = () => {
          return isRosreestrFeatureEnabled
            ? !this.ad.isByHomeowner
            : true;
        };

        const modalHintTitle = 'Кадастровый номер';
        const tooltipText = 'Номер в формате 47:14:1203001:814.<br />Указан в Свидетельстве о собственности.';

        this.openTooltipModal = () => {
          popupService.openPopup('hint', {
            text: tooltipText,
            title: modalHintTitle,
            hideCloseButton: false,
          });
        };

        this.unsubscribeHintListener = null;
        this.isHintTrackingInitialized = false;
  
        setTimeout(() => this.unsubscribeHintListener = initializeHintClickTracking('cadastral-number-hint', analyticsService.adAnalyticsCategory), 0);
  
        $scope.$on('$destroy', () => {
          if (this.unsubscribeHintListener) {
            this.unsubscribeHintListener();
          }
        });
      },
    ],
    controllerAs: 'cadastralNumber',
    template,
  })])
  .name;
